<div class="card">
  <div class="card-header d-flex justify-content-between">
    <h4 class="mb-0">
      <i class="fa-solid fa-tasks"></i> Survey
    </h4>
    <div class="d-flex" style="gap: 1em;">
      <span class="my-auto">{{ currentPage + 1 }} / {{ surveyQuestions.length }}</span>
      <span class="my-auto badge badge-success" *ngIf="giveaway.hasSurvey">passed</span>
    </div>
  </div>
  <div class="card-body">
    <form (ngSubmit)="submitSurvey()">
      <div *ngIf="currentPage < surveyQuestions.length">
        <h3>{{ surveyQuestions[currentPage].question }}</h3>
        <div class="row">
          <div class="col-md-12" *ngFor="let option of surveyQuestions[currentPage].answer">
            <label class="radio-card">
              <input class="form-check-input" type="radio" name="question_{{ currentPage }}" [value]="option"
                [(ngModel)]="surveyQuestions[currentPage].selectedOption" [disabled]="giveaway.hasSurvey"
                [ngModelOptions]="{standalone: true}" />
              <div class="card-content">
                {{ option }}
              </div>
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between  mt-4">
        <div class="d-flex" style="gap: 7px;">
          <button type="button" class="btn btn-sm btn-secondary" (click)="previousPage()"
            [disabled]="currentPage === 0">
            <i class="fa-solid fa-arrow-left"></i> Previous
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="nextPage()"
            [disabled]="currentPage === surveyQuestions.length - 1">
            Next <i class="fa-solid fa-arrow-right"></i>
          </button>
        </div>

        <div *ngIf="currentPage === surveyQuestions.length - 1 && !giveaway.hasSurvey">
          <button type="submit" class="btn btn-sm btn-success"><i class="fa-solid fa-save"></i> Submit</button>
        </div>
      </div>
    </form>
  </div>
</div>